'use strict';

angular.module('internal.services')
    .directive('internalServiceNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'services/components/service-navigation/service-navigation.html',
            replace: true,
            controller: ('InternalNavigation', ['$scope', 'Enterprise', function ($scope, Enterprise) {
                $scope.cliniciansImportOn = false;
                $scope.inspectionsModuleOn = false;
                Enterprise.get().then(function (enterprise) {
                    if (enterprise != null) {
                        $scope.cliniciansImportOn = (enterprise.clinicians_import == null ? false : enterprise.clinicians_import);
                        $scope.inspectionsModuleOn = (enterprise.inspections_module == null ? false : enterprise.inspections_module);
                    }
                })
            }])
        };
    }])
;